module.exports = __webpack_public_path__ + "img/arrow-forward.6cc5a963.svg";